<template>

    <v-container grid-list-xl>
    <v-divider class="mt-12"></v-divider>
    <h3 class="text-center">CARRITO COMPRAS</h3>
    <v-divider></v-divider>

<div v-if="$store.state.count!=0">
    <v-layout row wrap pa-2>
        <v-flex md6>

                <v-card
                    class="mx-auto mt-3"
                    color="white"
             
                    v-for="carrito in $store.state.producto" :key="carrito"
                >
                <v-list-item three-line>
                <v-list-item-content>
                    <v-list-item-title class="red--text mt-2"> <strong>{{carrito.categoria}} {{carrito.nombre}} </strong></v-list-item-title>
                   
                    <v-list-item-subtitle class="black--text  mt-1">
                      Precio : <strong>S/.{{carrito.precio}}</strong> </v-list-item-subtitle>

                    <v-list-item-subtitle class=" black--text mt-2">
                      <strong> TALLA  / </strong> </v-list-item-subtitle>

                      <v-list-item-subtitle >
                      <v-avatar class="mr-4 mt-2"
                      size="40">
                       <v-btn fab color="black">
                      <span class="white--text subtitle-1">{{carrito.talla}}</span>
                      </v-btn>
                    </v-avatar>

   
                      </v-list-item-subtitle>

                    </v-list-item-content>

                <v-list-item-avatar
                    size="100"
                >
                <v-img :src="carrito.color"></v-img>
                
                </v-list-item-avatar>
                </v-list-item>

                <v-card-actions>
                                         

                  <v-spacer></v-spacer>
                <v-btn class="red--text mt-n10 mr-5 caption" @click="
                $store.commit('increment',-1),
                $store.commit('sumacarrito', parseFloat(-carrito.precio)),
                $store.commit('sumatotalproductos',-1),
                $store.commit('eliminar',carrito.codigo)" text >Eliminar</v-btn>
                </v-card-actions>

                <v-overlay
                :absolute="absolute"
                :value="overlay"
                color="#036358"
                >
                </v-overlay>
            </v-card>

        </v-flex>
        <v-flex md6>
          <pasosConfirmaVenta/>
        </v-flex>
    </v-layout>



    <dialogoCliente/>
    <dialogoDireccion/>
</div>

<div class="text-center  mx-auto" v-if="$store.state.count==0">

    <v-img 
    class="text-center mx-auto"
    height="400"
    width="400"
     src="tienda.png">
    </v-img>

</div>
  </v-container>
</template>

<script>
import { db } from '../db'
import cuerpoprincipal from '@/components/cuerpoprincipal'
import mensajeCard from '@/components/mensajeCard'
import dialogoCliente from '@/components/dialogoCliente'
import dialogoDireccion from '@/components/dialogoDireccion'
import pasosConfirmaVenta from '@/components/pasosConfirmaVenta'
import store from '@/store/index'

 
  export default {
    name: 'pagCarrito',
      components: {
        cuerpoprincipal,
        mensajeCard,
        dialogoCliente,
        dialogoDireccion,
        pasosConfirmaVenta,
  },
      firebase: {
        producto: db.database().ref("producto"),

      },
          data() {
        return {
          carritofinal:[],
          absolute: true,
          overlay: false,
          producto:[],
          dato:1000,
          foto: 1,
          dialog : false,

        }
      },

       mounted() {
        if(store.state.count<=0){
           window.history.back();
        }
     },


    methods:{


        filtra(n){
            this.dato=''
            for(var i=0;i<this.producto.length;i++){
              if(n==this.producto[i].codigo){
                this.dato = (this.producto[i].stock)
                }
            }
            return this.dato
        },
              round(num, decimales = 2) {
              var signo = (num >= 0 ? 1 : -1);
              num = num * signo;
              if (decimales === 0) //con 0 decimales
                  return signo * Math.round(num);
              // round(x * 10 ^ decimales)
              num = num.toString().split('e');
              num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
              // x * 10 ^ (-decimales)
              num = num.toString().split('e');
              return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
          }
    }

  }
</script>
